export const TIME_FORMATS = {
  LOCALIZED_SHORT: "llll",
  FULL_WITH_FRACTIONAL_SECONDS: "ddd, MMM D, YYYY - H:mm:ss.SSS",
  SIMPLE_DATE_TIME: "ddd, MMM D, h:mm a",
  SIMPLE_DATE: "ddd, MMM D",
};
